"use strict";

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var nullthrows = function nullthrows(x) {
  if (x != null) {
    return x;
  }
  throw new Error("Got unexpected null or undefined");
};

module.exports = nullthrows;


/*****************
 ** WEBPACK FOOTER
 ** ./~/fbjs/lib/nullthrows.js
 ** module id = 41
 ** module chunks = 0
 **/